// extracted by mini-css-extract-plugin
export default {"page":"page-layout_page__KDZrg","pageBody":"page-layout_pageBody__CX3P6","scrollContainer":"page-layout_scrollContainer__Hr4uH"};